import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const InfoGlyph = /*#__PURE__*/createElement("g", {
  id: "info"
}, /*#__PURE__*/createElement("path", {
  d: "M42,18c13.2,0,24,10.8,24,24S55.2,66,42,66S18,55.2,18,42S28.8,18,42,18 M42,15c-14.9,0-27,12.1-27,27 s12.1,27,27,27s27-12.1,27-27S56.9,15,42,15L42,15z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,35.1c0.7,0,1.2-0.2,1.7-0.7c0.5-0.4,0.7-1.1,0.7-1.8c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.5-1.1-0.7-1.8-0.7 c-0.7,0-1.3,0.2-1.8,0.7c-0.5,0.5-0.7,1.1-0.7,1.8c0,0.8,0.3,1.4,0.8,1.8C40.8,34.9,41.3,35.1,42,35.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M44,50V39c0-1.1-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2s0.9,2,2,2v9c-1.1,0-2,0.9-2,2s0.9,2,2,2h4c1.1,0,2-0.9,2-2 S45.1,50,44,50z"
}));
const Info = createSvg({
  name: 'info',
  path: InfoGlyph
});

export default Info;
export { InfoGlyph };
